"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const route_utils_js_1 = require("../../vanilla/route-utils.js");
const Callback_component_js_1 = __importDefault(require("../default-component/Callback.component.js"));
const SilentCallback_component_js_1 = __importDefault(require("../default-component/SilentCallback.component.js"));
const SilentLogin_component_js_1 = __importDefault(require("../default-component/SilentLogin.component.js"));
const OidcRoutes = ({ callbackErrorComponent, callbackSuccessComponent, redirect_uri, silent_redirect_uri, silent_login_uri, children, configurationName, withCustomHistory = null, }) => {
    // This exist because in next.js window outside useEffect is null
    const pathname = window ? (0, route_utils_js_1.getPath)(window.location.href) : '';
    const [path, setPath] = (0, react_1.useState)(pathname);
    (0, react_1.useEffect)(() => {
        const setNewPath = () => setPath((0, route_utils_js_1.getPath)(window.location.href));
        setNewPath();
        window.addEventListener('popstate', setNewPath, false);
        return () => window.removeEventListener('popstate', setNewPath, false);
    }, []);
    const callbackPath = (0, route_utils_js_1.getPath)(redirect_uri);
    if (silent_redirect_uri) {
        if (path === (0, route_utils_js_1.getPath)(silent_redirect_uri)) {
            return (0, jsx_runtime_1.jsx)(SilentCallback_component_js_1.default, { configurationName: configurationName });
        }
    }
    if (silent_login_uri) {
        if (path === (0, route_utils_js_1.getPath)(silent_login_uri)) {
            return (0, jsx_runtime_1.jsx)(SilentLogin_component_js_1.default, { configurationName: configurationName });
        }
    }
    switch (path) {
        case callbackPath:
            return (0, jsx_runtime_1.jsx)(Callback_component_js_1.default, { callBackError: callbackErrorComponent, callBackSuccess: callbackSuccessComponent, configurationName: configurationName, withCustomHistory: withCustomHistory });
        default:
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
};
exports.default = react_1.default.memo(OidcRoutes);
//# sourceMappingURL=OidcRoutes.js.map